import Api from '@/services/Api'
const path = 'wines'

export default {
    index(name, year, region, type, winery, page) {
        return Api().get(path, {
            params: {
                name,
                year,
                region,
                type,
                winery,
                page
            }
        })
    },
    show(id) {
        return Api().get(path + `/show/${id}`);
    },
    addUpdate(wine) {
        return Api().post(path, wine);
    },
    uploadImgs(id, data) {
        return Api().post(
            path + `/uploadimgs/${id}`,
            data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        )
    },
    // deleteImg(id) {
    //     return Api().delete(path + `/deleteimg/${id}`)
    // },
    // delete(id) {
    //     return Api().delete(path + `/${id}`)
    // },
    deleteImg(id) {
        return Api().get(path + `/deleteimg/${id}`)
    },
    delete(id) {
        return Api().get(path + `/delete/${id}`)
    }
}